import { Resolution } from './recorder/RecorderVideo';

export { HaltReason } from '../../../../shared/features/room-agent/constants';

export const RECORDER_RESOLUTIONS: Record<string | number, Resolution> = {
    720: { width: 1280, height: 720 },
    1080: { width: 1920, height: 1080 },
};

export enum GeneralErrorReason {
    ICE_GATHERING_ERROR = 'ICE_GATHERING_ERROR',
    CONNECTION_ERROR = 'CONNECTION_ERROR',
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}
